import { render, staticRenderFns } from "./RegionalPolicies.vue?vue&type=template&id=5dc09272&scoped=true&"
import script from "./RegionalPolicies.vue?vue&type=script&lang=js&"
export * from "./RegionalPolicies.vue?vue&type=script&lang=js&"
import style0 from "./RegionalPolicies.vue?vue&type=style&index=0&id=5dc09272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc09272",
  null
  
)

/* custom blocks */
import block0 from "./RegionalPolicies.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VRow})
